/* eslint-disable react/react-in-jsx-scope */

import { message } from 'antd';
import router from 'umi/router';
import { getNoMatchList, update, ignore } from '../../services/abnormalData/abnormalData';
import { setSpinProps } from '@/utils/utils';

const initState = () => {
  return {
    /*
     * 表头 Array<Object>
     * type: 表头单元格类型 0:未匹配 1:部门名称 2:部门类型 Number
     * value: 表头单元格值 String
     */
    columns: [],
    /**
     * table数据 Array<Object>
     * type: 表头单元格类型 0:未匹配 1:部门名称 2:部门类型 Number
     * value: 表头单元格值 String
     */
    data: [],
    selectedRowKeys: [], // 选中的列
    pattern: 'show', // 渲染模式，show：展示模式，edit:编辑模式，默认：show
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
  };
};

export default {
  namespace: 'countyAbnormalData',

  state: initState(),

  subscriptions: {
    setup({ dispatch, history }) {
      // 当url参数变化的时候 清除一次缓存
      history.listen(({ pathname, query }) => {
        if (pathname.match(/^\/countyContacts\/abnormal$/)) {
          dispatch({
            type: 'reset',
          });
          dispatch({
            type: 'fetchList',
            params: { taskId: query.taskId, startNum: 0, num: 10 },
          });
        }
      });
    },
  },

  effects: {
    *fetchList({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { headers, rows } = yield call(getNoMatchList, params);

        if (!rows.length) {
          router.goBack();
        }

        // 数据重组
        const newRow = rows.map(item => {
          const { valueMap } = item;
          return {
            ...item,
            ...valueMap,
          };
        });

        // 设置错误数据渲染方式
        const columns = headers.map(attr => {
          const { dataIndex } = attr;
          return {
            ...attr,
            render: (text, record) => {
              const val = record[dataIndex];
              if (record.noMatchArr.includes(dataIndex)) {
                return <span className="table-error-data">{val}</span>;
              }

              return val;
            },
          };
        });

        yield setSpinProps({ put, columns, data: newRow, taskId: params.taskId, pattern: 'show' });
        yield;
      } catch (error) {
        console.error(error)
        yield setSpinProps({ put });
      }
    },
    // 忽略
    *fetchIgnore({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '忽略中...' });
        const { taskId, data, rowIdList, selectedRowKeys } = params;

        // 保存
        yield call(ignore, { taskId, rowIdList });

        // 去除刚更新的数据
        const newData = data.filter(({ rowId }) => !rowIdList.includes(rowId));
        const newSelectedRowKeys = selectedRowKeys.filter(item => !rowIdList.includes(item));
        message.success('忽略成功');

        yield setSpinProps({ put, data: newData, selectedRowKeys: newSelectedRowKeys });

        // 判断如果没有可以处理的数据了，则重新获取数据
        if (newData.length === 0) {
          yield put({
            type: 'fetchList',
            params: { taskId, startNum: 0, num: 10 },
          });
        }
      } catch (error) {
        console.error(error)
        yield setSpinProps({ put });
      }
    },
    // 保存
    *fetchSave({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '保存中...' });
        const { taskId, data, rowId, values, selectedRowKeys } = params;
        // 重组数据 将更新的数据加入到行数据中
        const thisRowData = data.find(({ rowId: thisRowId }) => thisRowId === rowId);
        const updateData = Object.assign({}, thisRowData, values);

        delete updateData.noMatchArr;
        delete updateData.valueMap;

        // 保存
        yield call(update, { taskId, updateArr: [updateData] });

        // 去除刚更新的数据
        const newData = data.filter(({ rowId: thisRowId }) => thisRowId !== rowId);
        const newSelectedRowKeys = selectedRowKeys.filter(item => rowId !== item);

        message.success('保存成功');

        yield setSpinProps({ put, data: newData, selectedRowKeys: newSelectedRowKeys });

        // 判断如果没有可以处理的数据了，则重新获取数据
        if (newData.length === 0) {
          yield put({
            type: 'fetchList',
            params: { taskId, startNum: 0, num: 10 },
          });
        }
      } catch (error) {
        console.error(error)
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    change(state, { render }) {
      const { columns } = state;
      const newColumns = columns.map(attr => {
        const { dataIndex } = attr;
        return {
          ...attr,
          render: (text, record) => render(dataIndex, text, record),
        };
      });

      return {
        ...state,
        pattern: 'edit',
        columns: newColumns,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
